module.exports = __webpack_public_path__ + "static/media/plus-finvaro.5c852605.svg";